// extracted by mini-css-extract-plugin
module.exports = {"ArticleContentFooter":"ArticleFooter_ArticleContentFooter_1YrFS","pageArrow":"ArticleFooter_pageArrow_1hMj_"};